import React from 'react';
import { motion } from 'framer-motion';
import { useWaveform } from '../hooks/useWaveform';
import { logger } from '../lib/logger';

interface WaveformVisualizerProps {
  audioUrl: string;
  isProcessing?: boolean;
}

export default function WaveformVisualizer({ audioUrl, isProcessing }: WaveformVisualizerProps) {
  const { error, isLoading } = useWaveform();

  return (
    <div className="space-y-6">
      {(isProcessing || isLoading) && (
        <div className="flex items-center justify-center h-32 bg-gray-900/50 rounded-lg border border-blue-500/20">
          <motion.div 
            className="relative w-16 h-16"
            animate={{ 
              rotate: 360,
            }}
            transition={{ 
              duration: 2,
              repeat: Infinity,
              ease: "linear"
            }}
          >
            <div className="processing-ring" />
            <div className="processing-ring" style={{ animationDelay: '-0.3s' }} />
            <div className="processing-ring" style={{ animationDelay: '-0.6s' }} />
          </motion.div>
        </div>
      )}

      {error && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="p-4 bg-red-900/20 text-red-400 rounded-lg border border-red-500/20"
        >
          {error}
        </motion.div>
      )}
    </div>
  );
}

export { WaveformVisualizer };